// extracted by mini-css-extract-plugin
module.exports = {"list":"_7002","item":"_1261","title":"_8685"};